import React from 'react';
import {COLOR} from "../common/constant";
import * as Icon from "ubs-icons";

const UPaymentBar = React.memo((props) => {
    return (
        <React.Fragment>
            <div className="u_maintenance-note">
                <p className="u_text-center">
                    <span className="u_lh-0"><Icon.Details className="u_mr-5" fill={COLOR.u_title} size={14}/></span><strong className="u_mr-5">IMPORTANT NOTE:</strong>{props?.title}
                </p>
            </div>
        </React.Fragment>
    );
});
export default UPaymentBar;